import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import {
    v3_public_share_detail,
    v3_public_share_download_url,
    v3_public_share_preview_url,
} from '../../actions/v3/dms';

const imageExtensions = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'svg'];

const extensionOf = (name = '') => String(name).toLowerCase().split('.').pop();

const Index = () => {
    const { token } = useParams();
    const [share, setShare] = useState(null);
    const [error, setError] = useState(null);
    const [active, setActive] = useState(null);

    useEffect(() => {
        v3_public_share_detail(token)
            .then((data) => {
                setShare(data);
                setActive(data.files?.[0] || null);
            })
            // The API answers 404/410/403 with {code, message}; show that verbatim
            // so an expired link reads as expired rather than as a generic failure.
            .catch((err) => setError(err.response?.data || { message: 'This link could not be opened.' }));
    }, [token]);

    if (error) {
        return (
            <div className="d-flex align-items-center justify-content-center vh-100 bg-light">
                <div className="text-center">
                    <i className="mdi mdi-link-variant-off" style={{ fontSize: 48, color: '#adb5bd' }} />
                    <h4 className="mt-3">{error.message}</h4>
                    <p className="text-muted">Please ask the sender for a new link.</p>
                </div>
            </div>
        );
    }

    if (!share) {
        return <div className="d-flex align-items-center justify-content-center vh-100">Loading…</div>;
    }

    const kind = active ? extensionOf(active.DISPLAY_NAME) : '';
    const previewUrl = active ? v3_public_share_preview_url(token, active.ID) : '';

    return (
        <div className="bg-light min-vh-100">
            <div className="container py-4">
                <div className="d-flex align-items-center mb-3">
                    <i className={`mdi ${share.scopeType === 'folder' ? 'mdi-folder text-warning' : 'mdi-file-document-outline'} me-2`} style={{ fontSize: 24 }} />
                    <h5 className="mb-0">{share.name}</h5>
                    <span className="badge bg-secondary ms-3">
                        {share.allowDownload ? 'View + download' : 'View only'}
                    </span>
                </div>

                <div className="row">
                    {share.scopeType === 'folder' && (
                        <div className="col-md-4">
                            <div className="card">
                                <div className="card-body p-2">
                                    {share.files.map((file) => (
                                        <div
                                            key={file.ID}
                                            className={`px-2 py-1 rounded d-flex align-items-center ${active?.ID === file.ID ? 'bg-light fw-semibold' : ''}`}
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => setActive(file)}
                                        >
                                            <i className="mdi mdi-file-document-outline me-2" />
                                            <span className="text-truncate" title={file.DISPLAY_NAME}>{file.DISPLAY_NAME}</span>
                                        </div>
                                    ))}
                                    {share.files.length === 0 && <p className="text-muted mb-0 p-2">This folder is empty.</p>}
                                </div>
                            </div>
                        </div>
                    )}

                    <div className={share.scopeType === 'folder' ? 'col-md-8' : 'col-12'}>
                        <div className="card">
                            <div className="card-body">
                                {active ? (
                                    <>
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <span className="text-truncate">{active.DISPLAY_NAME}</span>
                                            {share.allowDownload && (
                                                <a
                                                    className="btn btn-sm btn-primary"
                                                    href={v3_public_share_download_url(token, active.ID)}
                                                >
                                                    <i className="mdi mdi-download me-1" />Download
                                                </a>
                                            )}
                                        </div>

                                        {kind === 'pdf' ? (
                                            <iframe title={active.DISPLAY_NAME} src={previewUrl} width="100%" height="600px" style={{ border: 'none' }} />
                                        ) : imageExtensions.includes(kind) ? (
                                            <img src={previewUrl} alt={active.DISPLAY_NAME} style={{ maxWidth: '100%', display: 'block', margin: '0 auto' }} />
                                        ) : (
                                            <p className="text-muted text-center mb-0">
                                                Preview is not available for this file type.
                                                {!share.allowDownload && ' The sender has disabled downloads.'}
                                            </p>
                                        )}
                                    </>
                                ) : (
                                    <p className="text-muted mb-0">Nothing to show.</p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Index;
